module.exports = __webpack_public_path__ + "img/icon_ios.338429db.svg";